export const MAX_WIDTH = '960px'

export const SPACERS = {
	S: '5px',
	M: '10px',
	L: '20px',
	XL: '50px',
}

export const MQ = {
	S: '@media (min-width: 576px)',
	M: '@media (min-width: 768px)',
	L: '@media (min-width: 992px)',
	XL: '@media (min-width: 1200px)',
}

export const COLORS = {
	BLACK: '#263238',
	DARK_BLACK: '#000',
	DARK_GRAY: '#4c6672',
	GRAY: '#5f6060',
	GREEN: '#00Af66',
	PALE_GREEN: '#e3f2ec', // green decidd by this article https://www.wealthsimple.com/en-us/magazine/money-diary-weed-entrepreneur
	LIGHT_GRAY: '#EAEDEF',
	SUPER_LIGHT_GRAY: '#eff2f1',
	MEDIUM_LIGHT_GRAY: '#C4C8D8',
	PURPLE: '#32023e',
	RED: '#E8453C',
	WHITE: '#FFF',
}



// WEBPACK FOOTER //
// ./src/utils/styleHelpers.js